import axios from "axios";
import React, { useEffect, useState } from "react";
import DataGridComponent from "../../../Components/Forms/DataGridProComponent";
import parse from "html-react-parser";
import EnvioRotogramaViagemPopup from "../../Relatorios/RotogramaViagem/EnvioRotogramaViagemPopup";
import ColunasGridEmViagemPopup from "./ColunasGridEmViagemPopup";

const GridEmViagemTab = (props: any) => {
  const [dadosViagemGrid, setDadosViagemGrid] = useState<any[]>([]);
  const [dadosViagem, setDadosViagem] = useState<any>({});
  const [responseRows, setResponseRows] = useState<any>({});
  const [envioRotogramaOpen, setEnvioRotogramaOpen] = useState(false);
  const [colunasGridOpen, setColunasGridOpen] = useState(false);
  const [colunas, setColunas] = useState<any[]>([]);

  useEffect(() => {
    const carregar = async () => {
      await carregaGrid();
    };

    carregar();
  }, []);

  function onCloseColunasGrid() {
    setColunasGridOpen(false);
    carregaGrid();
  }

  async function carregaGrid() {
    let response: any = await axios.get(
      `colunasGridVisualizacao?gridId=em_viagem`,
    );

    let gridColunas = response.data.map((coluna: any) => ({
      dataIndex: coluna.identificador,
      title: coluna.nome,
      minWidth: coluna.width || 150,
      render: (value: string) => parse(`${(value  ?? '')}`),
      // flex: 0.2,
    }));

    setColunas(gridColunas);
  }

  async function atualizaListaBuscaCallBack(
    pageSize: number,
    pageNumber: number)
  {
    let response: any = await axios.get(
      `buscaDadosGridEmViagem?page=${pageNumber}&pageSize=${pageSize}`,
    );

    setDadosViagemGrid(response.data.data);
    props.setLabel(`Em Viagem (${response.data.total})`);

    setResponseRows(response);
  }

  function selecionaViagem(id: any) {
    setDadosViagem({ id: id });
    setEnvioRotogramaOpen(true);
  }

  return (
    <>
      <div className="col-md-12 mb-12" style={{ height: "100%" }}>
        <DataGridComponent
          heightFix={70}
          directionOptions="left"
          paginationSide="server"
          hideDelete={true}
          onEditAction={selecionaViagem}
          onDeleteAction={() => alert(1)}
          responseRows={responseRows}
          columns={colunas}
          pageSizeOptions={["15", "30", "50", "100"]}
          atualizaListaBuscaCallBack={atualizaListaBuscaCallBack}
          openGridSettings={() => setColunasGridOpen(true)}
        />
      </div>
      {colunasGridOpen ? (
        <ColunasGridEmViagemPopup
          isOpen={colunasGridOpen}
          onClose={() => onCloseColunasGrid()}
        />
      ) : (
        ""
      )}

      {envioRotogramaOpen ? (
        <EnvioRotogramaViagemPopup
          viagemId={dadosViagem.id}
          isOpen={envioRotogramaOpen}
          onClose={() => setEnvioRotogramaOpen(false)}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default GridEmViagemTab;
